import Axios from 'axios';
import qs from 'qs';
import { handleError } from '@/_helpers/utils.js';

export default {
  namespaced: true,

  state() {
    return {
      vcv_tags_list: [],
      vcv_tags_suggestions: [],
      vcv_tags_search_suggestions: [],
      vcv_tags_response_list: [],
      fetch_params: {
        page: 1,
        limit: 9999,
        with: ['tag']
      }
    };
  },

  mutations: {
    SET_LIST(state, data) {
      state[data.list] = data.value;
    }
  },

  actions: {
    async fetchVcvTagsSuggestions({ state, commit, dispatch }, payload) {
      let params = state.fetch_params;
      params.filter = [];
      params.filter['name'] = payload.query;

      return await Axios.get('/v3/tags', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(response => {
          commit('SET_LIST', { list: payload.list, value: response.data._embedded.tags });
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          Promise.reject(handleError(err));
        });
    },

    async fetchVcvTagsList({ state, commit, dispatch }) {
      let params = state.fetch_params;
      if (params.filter) delete params.filter;

      return await Axios.get('/v3/tags', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(response => {
          commit('SET_LIST', { list: 'vcv_tags_list', value: response.data._embedded.tags });
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          Promise.reject(handleError(err));
        });
    },

    async fetchVcvTagsResponseList({ commit, dispatch }, id) {
      let params = {
        page: 1,
        limit: 9999,
        with: ['tag'],
        filter: {
          response_id: id
        }
      };

      return await Axios.get('/v3/response-tags', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(response => {
          commit('SET_LIST', {
            list: 'vcv_tags_response_list',
            value: response.data._embedded.response_tags
          });
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          Promise.reject(handleError(err));
        });
    },

    async addVcvTag({ dispatch }, name) {
      let params = { name, sort_order: 1 };

      return await Axios.post('/v3/tags', {
        ...params,
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(res => {
          return res.data;
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          Promise.reject(handleError(err));
        });
    },

    async editVcvTag({ dispatch }, payload) {
      return await Axios.patch(`/v3/tags/${payload.id}`, {
        ...payload.params,
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(res => {
          return res.data;
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          Promise.reject(handleError(err));
        });
    },

    async deleteVcvTag({ dispatch }, id) {
      return await Axios.delete(`/v3/tags/${id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          Promise.reject(handleError(err));
        });
    },

    async addVcvResponseTag({ dispatch }, params) {
      return await Axios.post('/v3/response-tags', {
        ...params,
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(() => {
          dispatch('fetchVcvTagsResponseList', params.response_id);
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          Promise.reject(handleError(err));
        });
    },

    async deleteVcvResponseTag({ dispatch }, params) {
      return await Axios.delete(`/v3/response-tags/${params.id}`)
        .then(() => {
          dispatch('fetchVcvTagsResponseList', params.response_id);
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          Promise.reject(handleError(err));
        });
    }
  },

  getters: {
    getVcvTagsSuggestions: state => search => {
      let result = [];

      state.vcv_tags_suggestions.forEach(tag => {
        const list = state.vcv_tags_response_list;
        const filtered = list.filter(item => item.tag_id === tag.id);

        if (filtered.length === 0) {
          result.push({
            ...tag,
            name: tag.name.replace(new RegExp(`${search}`, 'gi'), `<strong>${search}</strong>`)
          });
        }
      });

      return result;
    }
  }
};
